export const Progress = ({ steps, current }) => (
  <div className="mb-10" data-testid="booking-progress">
    <div className="lg:hidden">
      <p className="text-[11px] uppercase tracking-[0.3em] text-white/50">
        Step {current + 1} of {steps.length} —{" "}
        <span className="text-hotpink">{steps[current]}</span>
      </p>
      <div className="mt-3 h-1 rounded-full bg-white/10">
        <div
          className="h-full rounded-full bg-hotpink transition-[width] duration-500"
          style={{ width: `${((current + 1) / steps.length) * 100}%` }}
        />
      </div>
    </div>

    <ol className="hidden items-start lg:flex">
      {steps.map((s, i) => (
        <li key={s} className="flex flex-1 items-center last:flex-none">
          <div className="flex flex-col items-center gap-2">
            <span
              className={`flex h-8 w-8 items-center justify-center rounded-full border text-xs font-bold transition-colors duration-500 ${
                i <= current
                  ? "border-hotpink bg-hotpink text-white"
                  : "border-white/20 text-white/40"
              }`}
            >
              {i + 1}
            </span>
            <span
              className={`text-[9px] uppercase tracking-[0.2em] ${
                i <= current ? "text-white" : "text-white/35"
              }`}
            >
              {s}
            </span>
          </div>
          {i < steps.length - 1 && (
            <span
              className={`mx-2 mb-6 h-px flex-1 transition-colors duration-500 ${
                i < current ? "bg-hotpink" : "bg-white/15"
              }`}
            />
          )}
        </li>
      ))}
    </ol>
  </div>
);

